import React, { Component } from "react";
import config from "./../../common/config";
import { Redirect } from "react-router-dom";
import { getParams } from "../../common";
class NoMatch extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const sSearch = getParams();
    let sRedirect = config.redirectDefault;
    sRedirect = `${sRedirect}${sSearch}`;
    return <Redirect to={sRedirect} push />;
  }
}

export default NoMatch;
